import { FormEvent, useContext, useState } from 'react';
import { UserContext } from '../../../context/authContext';
import { DocumentContext } from '../../../context/documentContext';
import axios from 'axios';
import { PasswordMatch, PasswordChecker } from '../passwordChecker';
import useLocalStorage from '../../../hooks/localStorage';
import { useNavigate } from 'react-router-dom';

export const ChangePassword = () => {
  const { auth } = useContext(UserContext);
  const { setMainAlert } = useContext(DocumentContext);
  const navigate = useNavigate();
  const [first, setFirst] = useState<string>('');
  const [second, setSecond] = useState<string>('');
  const [old, setOld] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [storedAccessToken] = useLocalStorage<string>('accessToken', '');

  const canSubmit =
    first === second && (first !== '' || second !== '' || old !== '');

  const updatePassword = async () => {
    try {
      console.log('stored Access', storedAccessToken);
      const results = await axios.post(
        `${process.env.REACT_APP_KORU_API}/user?type=changeOwnPassword`,
        {
          oldPassword: old,
          newPassword: second,
          accessToken: storedAccessToken
        },

        auth
      );
      setMainAlert({
        showAlert: true,
        message: 'Password Reset',
        alertType: 'success'
      });
      console.log(results);
    } catch (e) {
      setMainAlert({
        showAlert: true,
        message: 'Error resetting password',
        alertType: 'error'
      });
    }
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!canSubmit || isLoading) return;
    setIsLoading(true);
    try {
      await updatePassword();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="mt-10">
      <div className="rounded-3xl border border-white/60 bg-white/90 p-8  backdrop-blur">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-slate-900">
            Change Password
          </h2>
          <p className="mt-2 text-sm text-slate-500">
            Use a strong password that you don’t use anywhere else.
          </p>
        </div>
        <form className="space-y-6 " onSubmit={handleSubmit}>
          <div className="rounded-2xl p-4 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.4)]">
            <label className="flex flex-col gap-2 text-sm font-medium text-slate-700">
              Current Password
              <input
                type="password"
                value={old}
                onChange={(event) => setOld(event.target.value)}
                className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base text-slate-900 shadow-sm focus:border-emerald-400 focus:ring-2 focus:ring-emerald-200/60"
                placeholder="Enter current password"
              />
            </label>
            <label className="flex flex-col gap-2 text-sm font-medium text-slate-700">
              New Password
              <input
                type="password"
                aria-label="New Password"
                value={first}
                onChange={(event) => setFirst(event.target.value)}
                className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base text-slate-900 shadow-sm focus:border-emerald-400 focus:ring-2 focus:ring-emerald-200/60"
                placeholder="Create a new password"
              />
            </label>
            {first.length > 0 ? (
              <div className="rounded-2xl border border-emerald-100 bg-emerald-50/60 p-4 text-sm text-emerald-900 shadow-sm">
                <PasswordChecker value={first} />
              </div>
            ) : null}
            <label className="flex flex-col gap-2 text-sm font-medium text-slate-700">
              Confirm New Password
              <input
                type="password"
                value={second}
                onChange={(event) => setSecond(event.target.value)}
                className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base text-slate-900 shadow-sm focus:border-emerald-400 focus:ring-2 focus:ring-emerald-200/60"
                placeholder="Retype new password"
              />
            </label>
            {second.length > 0 ? (
              <div className="rounded-2xl border border-sky-100 bg-sky-50/60 p-4 text-sm text-sky-900 shadow-sm">
                <PasswordMatch first={first} second={second} />
              </div>
            ) : null}
          </div>

          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div>
              <p className="text-sm font-medium text-slate-800">
                Secure your workspace
              </p>
              <p className="text-sm text-slate-500">
                Updating your password signs you out of other active sessions.
              </p>
            </div>
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => navigate('/app/landing')}
                className="rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-100"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!canSubmit || isLoading}
                className="rounded-full bg-emerald-500 px-6 py-2 text-sm font-semibold text-white shadow-lg transition-colors disabled:cursor-not-allowed disabled:opacity-70 hover:bg-emerald-600"
              >
                {isLoading ? 'Saving…' : 'Save Password'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};
